import { render, staticRenderFns } from "./crudMessage.vue?vue&type=template&id=62f1e426&"
import script from "./crudMessage.vue?vue&type=script&lang=js&"
export * from "./crudMessage.vue?vue&type=script&lang=js&"
import style0 from "./crudMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports